import styled from 'styled-components';
import { ColorTheme, TextTheme, SpacingTheme, BorderRadiusTheme, ShadowTheme } from '../globaStyledComponents/globalStyledComponentsStyling';

export const HeaderText = styled.h2`
    font-size: 24px;
    font-family: "Altform Semibold";
    color: ${ColorTheme.Black.color};
    margin: 48px 0 24px 0;
    text-align: center;
`;

export const SubHeaderText = styled.p`
    font-size: 14px;
    color: ${ColorTheme.Grey.color};
    margin: 0 0 24px 0;
    text-align: center;
    line-height: 1.4;
`;

export const CurrencyList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 300px;
    overflow-y: auto;
    margin-bottom: 16px;
`;

export const CurrencyItem = styled.div<{ isSelected: boolean }>`
    display: flex;
    align-items: center;
    padding: 16px;
    margin: 0 24px;
    border-radius: ${BorderRadiusTheme.radius_16.borderRadius};
    border: 2px solid ${props => props.isSelected ? ColorTheme.Black.color : ColorTheme.Grey1.color};
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;

    &:hover {
        border-color: ${props => props.isSelected ? ColorTheme.Black.color : ColorTheme.Grey.color};
    }

    &:active {
        transform: translateY(1px);
    }
`;

export const CurrencySymbol = styled.div`
    font-size: 24px;
    font-weight: 600;
    color: ${ColorTheme.Black.color};
    margin-right: 16px;
    min-width: 40px;
    text-align: center;
`;

export const CurrencyLabel = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: ${ColorTheme.Black.color};
    margin-bottom: 2px;
`;

export const CurrencyText = styled.div`
    font-size: 14px;
    color: ${ColorTheme.Grey.color};
    line-height: 1.3;
`;

export const SelectedIndicator = styled.div`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${ColorTheme.Black.color};
    color: ${ColorTheme.White.color};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
`;
